import { SettingsItemNavigate } from 'design-system';
import { IconHome, IconLocation, IconPostageStamp, IconUnion, } from 'design-system/icons';
import { IconGlobeGradient } from 'design-system/icons/IconGlobeGradient';
import IconLocationTick from 'design-system/icons/IconLocationTick';
import { IconRoad } from 'design-system/icons/IconRoad';
import React, { memo } from 'react';
export const strings = {
    street: 'Street',
    town: 'Town / City',
    postCode: 'Postcode',
    zipCode: 'Zip code',
    state: 'State',
    county: 'County / Region',
    flatNumber: 'Flat number (optional)',
    buildingName: 'Building name (optional)',
    subBuildingName: 'Apartment / House',
    buildingNumber: 'Building / Street number',
    verifyAddressBtn: 'Verify address',
};
const AddressDisplay = ({ address }) => {
    if (address.countryIsoCode !== 'GB') {
        return (<>
        <SettingsItemNavigate disabled title={address.postcode} icon={<IconPostageStamp />} description={strings.zipCode}/>
        {!!address.subBuildingName && (<SettingsItemNavigate disabled icon={<IconUnion />} title={address.subBuildingName} description={strings.subBuildingName}/>)}
        {!!address.buildingNumber && (<SettingsItemNavigate disabled icon={<IconHome gradientKey="apricot"/>} title={address.buildingNumber} description={strings.buildingNumber}/>)}
        <SettingsItemNavigate disabled icon={<IconRoad />} title={address.streetName} description={strings.street}/>
        <SettingsItemNavigate disabled description={strings.town} title={address.townOrCity} icon={<IconLocation gradientKey="lightPink"/>}/>
        <SettingsItemNavigate disabled description={strings.state} title={address.stateCode} icon={<IconLocationTick />}/>
      </>);
    }
    return (<>
      <SettingsItemNavigate disabled title={address.postcode} icon={<IconPostageStamp />} description={strings.postCode}/>
      {!!address.subBuildingName && (<SettingsItemNavigate disabled icon={<IconUnion />} title={address.subBuildingName} description={strings.flatNumber}/>)}
      {!!address.buildingName && (<SettingsItemNavigate disabled icon={<IconHome gradientKey="orange"/>} title={address.buildingName} description={strings.buildingName}/>)}
      {!!address.buildingNumber && (<SettingsItemNavigate disabled icon={<IconHome gradientKey="apricot"/>} title={address.buildingNumber} description={strings.buildingNumber}/>)}
      <SettingsItemNavigate disabled icon={<IconRoad />} title={address.streetName} description={strings.street}/>
      <SettingsItemNavigate disabled description={strings.town} title={address.townOrCity} icon={<IconLocation gradientKey="lightPink"/>}/>
      <SettingsItemNavigate disabled icon={<IconGlobeGradient gradientKey="darkPink"/>} title={address.county} description={strings.county}/>
    </>);
};
export default memo(AddressDisplay);
